<template>
  <div v-loading="isLoading" class="text-black fs-16 relative">
    <!-- <div @click="()=>{$router.go(-1)}" class="absolute top-0 right-0 fs-34 cursor-pointer">&times;</div> -->
    <div class="flex justify-between items-center pb-2 cs-border-b">
      <h2 class="fs-18 mb-0">{{ $t('Chi tiết Báo cáo') }}</h2>
      <div class="flex gap-2 items-center">
        <el-switch v-model="form.isAvailable" active-color="#13ce66" active-text="Công bố"></el-switch>
      </div>
    </div>
    <div class="py-6 flex flex-col items-center gap-6 hodo-el">
      <div class="flex flex-col md:flex-row w-full justify-start items-center gap-4">
        <div class="flex-1 flex gap-2 items-center">
          <span class>{{ $t('Mã báo cáo:') }}</span>
          <el-input class="flex-1" v-model="form.paper_code" />
        </div>
        <div class="flex-1 flex w-full">
          <span class="mr-1">{{ $t('Báo cáo viên:') }}</span>
          <span v-if="reportData.authors" class="font-bold">{{ reportData.authors }}</span>
        </div>
      </div>
      <div class="flex flex-col lg:flex-row w-full gap-4">
        <div class="flex-1 flex flex-col gap-2">
          <label class="required">{{ $t('Thời gian bắt đầu') }}</label>
          <input
            class="form--input bg-white border h-10"
            type="datetime-local"
            v-model="form.startTime"
            :min="currentDate"
          />
        </div>
        <div class="flex-1 flex flex-col gap-2">
          <label class="required">{{ $t('Thời lượng') }}</label>
          <el-input
            class="cs-el-input form--input px-0"
            :placeholder="$t('Nhập thời lượng')"
            type="number"
            v-model="form.duration"
          >
            <template slot="append">{{ $t('Phút') }}</template>
          </el-input>
        </div>
      </div>
      <div class="flex flex-col gap-3 w-full">
        <div
          v-for="(item,index) in form.sessionMultiLang"
          :key="index"
          class="flex flex-col lg:flex-row gap-4 w-full"
        >
          <div class="flex-1">
            <label
              :class="item.lang===LANGUAGE_CODES_FOR_DISEASE.VI&&'required'"
              class="font-bold"
            >{{ handleGetLabel(item).title }}</label>
            <el-input
              type="textarea"
              :rows="4"
              :placeholder="$t('Nhập tên phiên')"
              v-model="item.title"
            ></el-input>
          </div>
          <div class="flex-1">
            <label
              :class="item.lang===LANGUAGE_CODES_FOR_DISEASE.VI&&'required'"
              class="font-bold"
            >{{ handleGetLabel(item).abstract }}</label>
            <el-input
              type="textarea"
              :rows="4"
              :placeholder="$t('Nhập tóm tắt')"
              v-model="item.abstract"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="w-full">
        <label class="font-bold">{{ $t('Tài liệu') }}</label>
        <div class="border rounded py-8 px-4">
          <div class="flex flex-col gap-2 mb-3">
            <div
              v-for="(docItem,index) in form.documents"
              :key="index"
              class="flex justify-between"
            >
              <div class="flex items-center gap-2">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.4793 11.3295V20.4577C20.4793 21.0544 20.2423 21.6266 19.8204 22.0486C19.3985 22.4705 18.8262 22.7075 18.2295 22.7075H7.7303C7.13361 22.7075 6.56135 22.4705 6.13943 22.0486C5.7175 21.6266 5.48047 21.0544 5.48047 20.4577V5.45881C5.48047 4.86212 5.7175 4.28987 6.13943 3.86794C6.56135 3.44602 7.13361 3.20898 7.7303 3.20898H12.3589C12.7565 3.20904 13.1379 3.36702 13.4191 3.64817L20.0401 10.2692C20.3213 10.5505 20.4793 10.9318 20.4793 11.3295Z"
                    stroke="#20409b"
                    stroke-width="1.49989"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.9795 3.58398V9.20856C12.9795 9.60636 13.1375 9.98786 13.4188 10.2691C13.7001 10.5504 14.0816 10.7084 14.4794 10.7084H20.104"
                    stroke="#20409b"
                    stroke-width="1.49989"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.22949 14.458H16.7289"
                    stroke="#20409b"
                    stroke-width="1.49989"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.22949 18.208H16.7289"
                    stroke="#20409b"
                    stroke-width="1.49989"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <a
                  :href="docItem.url"
                  target="_blank"
                  class="cs-link cursor-pointer italic mt-1"
                >{{ docItem.name }}</a>
              </div>
              <svg
                @click="handleDeleteDoc(docItem)"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="cursor-pointer"
              >
                <path
                  d="M10 18C10.2652 18 10.5196 17.8946 10.7071 17.7071C10.8946 17.5196 11 17.2652 11 17V11C11 10.7348 10.8946 10.4804 10.7071 10.2929C10.5196 10.1054 10.2652 10 10 10C9.73478 10 9.48043 10.1054 9.29289 10.2929C9.10536 10.4804 9 10.7348 9 11V17C9 17.2652 9.10536 17.5196 9.29289 17.7071C9.48043 17.8946 9.73478 18 10 18ZM20 6H16V5C16 4.20435 15.6839 3.44129 15.1213 2.87868C14.5587 2.31607 13.7956 2 13 2H11C10.2044 2 9.44129 2.31607 8.87868 2.87868C8.31607 3.44129 8 4.20435 8 5V6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7C3 7.26522 3.10536 7.51957 3.29289 7.70711C3.48043 7.89464 3.73478 8 4 8H5V19C5 19.7956 5.31607 20.5587 5.87868 21.1213C6.44129 21.6839 7.20435 22 8 22H16C16.7956 22 17.5587 21.6839 18.1213 21.1213C18.6839 20.5587 19 19.7956 19 19V8H20C20.2652 8 20.5196 7.89464 20.7071 7.70711C20.8946 7.51957 21 7.26522 21 7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM10 5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4H13C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5V6H10V5ZM17 19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H8C7.73478 20 7.48043 19.8946 7.29289 19.7071C7.10536 19.5196 7 19.2652 7 19V8H17V19ZM14 18C14.2652 18 14.5196 17.8946 14.7071 17.7071C14.8946 17.5196 15 17.2652 15 17V11C15 10.7348 14.8946 10.4804 14.7071 10.2929C14.5196 10.1054 14.2652 10 14 10C13.7348 10 13.4804 10.1054 13.2929 10.2929C13.1054 10.4804 13 10.7348 13 11V17C13 17.2652 13.1054 17.5196 13.2929 17.7071C13.4804 17.8946 13.7348 18 14 18Z"
                  fill="red"
                />
              </svg>
            </div>
          </div>
          <div class="flex flex-col items-center mt-4">
            <div class="cs-upload px-10 py-6">
              <svg
                @click="handleTriggerUpload"
                class="cursor-pointer"
                width="80"
                height="80"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.4199 8.2199C17.8089 6.8159 16.7544 5.65097 15.418 4.90362C14.0815 4.15627 12.5369 3.86773 11.0209 4.0822C9.50477 4.29668 8.10082 5.00235 7.02415 6.09107C5.94747 7.17979 5.25748 8.59151 5.05989 10.1099C4.10648 10.3382 3.27011 10.9087 2.70963 11.7131C2.14914 12.5174 1.90357 13.4996 2.01955 14.4731C2.13553 15.4466 2.60498 16.3436 3.33876 16.9938C4.07253 17.6439 5.01952 18.002 5.99989 17.9999C6.26511 17.9999 6.51946 17.8945 6.707 17.707C6.89453 17.5195 6.99989 17.2651 6.99989 16.9999C6.99989 16.7347 6.89453 16.4803 6.707 16.2928C6.51946 16.1053 6.26511 15.9999 5.99989 15.9999C5.46946 15.9999 4.96075 15.7892 4.58568 15.4141C4.2106 15.039 3.99989 14.5303 3.99989 13.9999C3.99989 13.4695 4.2106 12.9608 4.58568 12.5857C4.96075 12.2106 5.46946 11.9999 5.99989 11.9999C6.26511 11.9999 6.51946 11.8945 6.707 11.707C6.89453 11.5195 6.99989 11.2651 6.99989 10.9999C7.00244 9.81717 7.42418 8.67365 8.19016 7.77248C8.95614 6.87131 10.0168 6.27085 11.1836 6.07777C12.3505 5.88469 13.548 6.1115 14.5635 6.7179C15.5789 7.32431 16.3465 8.27104 16.7299 9.3899C16.7871 9.56174 16.8898 9.71483 17.0272 9.83283C17.1646 9.95083 17.3314 10.0293 17.5099 10.0599C18.176 10.1858 18.7798 10.5335 19.2229 11.0464C19.6661 11.5594 19.9225 12.2073 19.9503 12.8845C19.9781 13.5618 19.7758 14.2286 19.3762 14.7761C18.9766 15.3237 18.4034 15.7198 17.7499 15.8999C17.4926 15.9662 17.2722 16.132 17.1372 16.3608C17.0022 16.5896 16.9636 16.8626 17.0299 17.1199C17.0962 17.3772 17.262 17.5975 17.4908 17.7326C17.7196 17.8676 17.9926 17.9062 18.2499 17.8399C19.3023 17.5618 20.2352 16.9479 20.9069 16.0914C21.5786 15.2348 21.9525 14.1825 21.9717 13.0942C21.991 12.0058 21.6545 10.9409 21.0135 10.0612C20.3724 9.18149 19.4618 8.53499 18.4199 8.2199ZM12.7099 10.2899C12.6148 10.1989 12.5026 10.1275 12.3799 10.0799C12.1364 9.97988 11.8634 9.97988 11.6199 10.0799C11.4971 10.1275 11.385 10.1989 11.2899 10.2899L8.28989 13.2899C8.10159 13.4782 7.9958 13.7336 7.9958 13.9999C7.9958 14.2662 8.10159 14.5216 8.28989 14.7099C8.47819 14.8982 8.73359 15.004 8.99989 15.004C9.26619 15.004 9.52159 14.8982 9.70989 14.7099L10.9999 13.4099V18.9999C10.9999 19.2651 11.1052 19.5195 11.2928 19.707C11.4803 19.8945 11.7347 19.9999 11.9999 19.9999C12.2651 19.9999 12.5195 19.8945 12.707 19.707C12.8945 19.5195 12.9999 19.2651 12.9999 18.9999V13.4099L14.2899 14.7099C14.3829 14.8036 14.4935 14.878 14.6153 14.9288C14.7372 14.9796 14.8679 15.0057 14.9999 15.0057C15.1319 15.0057 15.2626 14.9796 15.3845 14.9288C15.5063 14.878 15.6169 14.8036 15.7099 14.7099C15.8036 14.6169 15.878 14.5063 15.9288 14.3845C15.9796 14.2626 16.0057 14.1319 16.0057 13.9999C16.0057 13.8679 15.9796 13.7372 15.9288 13.6153C15.878 13.4935 15.8036 13.3829 15.7099 13.2899L12.7099 10.2899Z"
                  fill="#20409B"
                />
              </svg>
              <div>{{ $t('Tải lên tài liệu') }}</div>
            </div>
          </div>

          <input ref="uploadFileRef" type="file" multiple class="hidden" @change="handleUploadFile" />
        </div>
        <div class="flex flex-col gap-2 w-full mt-4">
          <label class="font-bold">{{ $t('Từ khoá') }}</label>

          <el-select
            v-model="form.keywords"
            multiple
            filterable
            allow-create
            default-first-option
            :placeholder="$t('Nhập từ khoá')"
          >
            <el-option
              v-for="item in worksSuggestion"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="mt-4">
        <button
          @click="handleSubmitData"
          style="min-width:350px"
          class="flex items-center justify-center border-0 focus:outline-none mx-3 bg-blue-700 text-white rounded-md h-10 px-3 py-2"
        >
          <div>{{ $t('Lưu Báo cáo') }}</div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { LANGUAGE_CODES_FOR_DISEASE } from '@/lang'

const DEFAULT_FORM = {
  sessionMultiLang: [
    {
      title: '',
      abstract: '',
      lang: LANGUAGE_CODES_FOR_DISEASE.VI
    },
    {
      title: '',
      abstract: '',
      lang: LANGUAGE_CODES_FOR_DISEASE.EN
    },
    {
      title: '',
      abstract: '',
      lang: LANGUAGE_CODES_FOR_DISEASE.FR
    }
  ],
  documents: [],
  startTime: window.moment().format('YYYY-MM-DDTHH:mm'),
  duration: '',
  isAvailable: false,
  paper_code: '',
  keywords: []
}

export default {
  name: 'ReportDetail',
  data () {
    return {
      currentDate: window.moment().format('YYYY-MM-DDTHH:mm'),
      form: { ...DEFAULT_FORM },
      LANGUAGE_CODES_FOR_DISEASE,
      reportData: {},
      worksSuggestion: [
        {
          value: 1,
          label: 'Hodo'
        },
        {
          value: 2,
          label: 'Conference'
        },
        {
          value: 3,
          label: 'Report'
        }
      ],
      DEFAULT_FORM,
      isLoading: false
    }
  },
  watch: {
    '$route.query.reportId': {
      async handler (data) {
        if (data) {
          await this.handleGetReportDetail()
        } else {
          this.form = { ...this.DEFAULT_FORM }
        }
      }
    }
  },
  async created () {
    await this.handleGetReportDetail()
  },
  methods: {
    async handleGetReportDetail () {
      if (!this.$route.query?.reportId) return

      try {
        this.isLoading = true
        const response = await this.$rf
          .getRequest('ConferenceRequest')
          .getConferenceReportDetail(this.$route.query?.reportId)

        const responseData = response.data || {}
        this.reportData = responseData

        const newSessionMultiLang = this.form.sessionMultiLang?.map(item => {
          const itemLang = responseData?.conference_submit_page_multi?.find(
            itemData => itemData?.lang === item.lang
          )

          return {
            ...item,
            title: itemLang?.title || '',
            abstract: itemLang?.abstract || ''
          }
        })

        this.form = {
          ...this.form,
          paper_code: responseData?.paper_code,
          startTime: window
            .moment(responseData?.schedule_time)
            .format('YYYY-MM-DDTHH:mm'),
          duration: responseData?.duration,
          sessionMultiLang: newSessionMultiLang,
          documents: responseData?.file_management?.files || [],
          isAvailable: responseData?.is_available === 2,
          keywords: responseData?.keywords
            ? responseData?.keywords?.split(' ,')
            : []
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    handleUploadFile (e) {
      const files = e.target.files

      for (let i = 0; i <= files.length; i++) {
        const url = window.URL.createObjectURL(files[i])
        files[i].url = url
        this.form.documents.push(files[i])
      }
    },
    handleTriggerUpload () {
      this.$refs.uploadFileRef.click()
    },
    handleGetLabel (data) {
      switch (data.lang) {
        case LANGUAGE_CODES_FOR_DISEASE.VI:
          return {
            abstract: this.$t('Tóm tắt (Tiếng Việt)'),
            title: this.$t('Tên bài Báo cáo (Tiếng Việt)')
          }
        case LANGUAGE_CODES_FOR_DISEASE.EN:
          return {
            abstract: this.$t('Tóm tắt (Tiếng Anh)'),
            title: this.$t('Tên bài Báo cáo (Tiếng Anh)')
          }
        case LANGUAGE_CODES_FOR_DISEASE.FR:
          return {
            abstract: this.$t('Tóm tắt (Tiếng Pháp)'),
            title: this.$t('Tên bài Báo cáo (Tiếng Pháp)')
          }

        default:
          return {
            abstract: this.$t('Tóm tắt (Tiếng Việt)'),
            title: this.$t('Tên bài Báo cáo (Tiếng Việt)')
          }
      }
    },
    handleDeleteDoc (item) {
      this.form.documents = this.form.documents.filter(
        doc => doc.id !== item.id
      )
    },
    async handleSubmitData () {
      if (!this.$route.query?.reportId) return

      try {
        this.isLoading = true

        const fileUrls = await this.handleUploadFiles()
        const params = {
          files: fileUrls || [],
          is_available: this.form.isAvailable ? 2 : 1,
          paper_code: this.form.paper_code,
          multiple_lan: this.form.sessionMultiLang?.map(item => ({
            lang: item.lang,
            title: item.title,
            abstract: item.abstract
          })),
          keywords: this.form.keywords.join(' ,'),
          schedule_time: window.moment(this.form.startTime).valueOf(),
          duration: Number(this.form.duration)
        }

        await this.$rf
          .getRequest('ConferenceRequest')
          .updateConferenceReport(this.$route.query?.reportId, params)

        this.$toast.open({
          message: this.$t('Cập nhật thông tin báo cáo thành công'),
          type: 'success'
        })

        this.handleGetReportDetail()
      } catch (error) {
        console.log(error)

        this.$toast.open({
          message: this.$t('Cập nhật thông tin báo cáo không thành công'),
          type: 'error'
        })
      } finally {
        this.isLoading = false
      }
    },
    async handleUploadFiles () {
      if (!this.form.documents?.length) return []

      try {
        const fileUrls = await Promise.allSettled(
          this.form.documents?.map(async file => {
            delete file.url
            if (!file.lastModifiedDate) {
              return { url: file.url, name: file.name }
            }

            const params = {
              file,
              FolderTarget: 'ConferenceReport',
              IdTarget: this.$route.query?.reportId
            }
            const formData = new FormData()
            for (const key in params) {
              formData.append(key, params[key])
            }

            const res = await this.$rf
              .getRequest('DoctorRequest')
              .uploadFileTenant(formData)
            return { url: res.data.fileUrl, name: file.name }
          })
        )

        return fileUrls
          ?.filter(item => item.status === 'fulfilled')
          .map(itemMap => itemMap?.value)
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    }
  },
  destroyed () {
    this.form = { ...this.DEFAULT_FORM }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .hodo-el {
    .el-input__inner {
      background: white !important;
      border: 1px solid #dee2e6 !important;
    }
  }
  .cs-border-b {
    border-bottom: 1px solid #000;
  }

  ::v-deep {
    .el-textarea__inner {
      border-radius: 10px;
      border-color: #20409b;
    }
  }

  .cs-border {
    border: 1px solid #20409b;
    border-radius: 10px;
  }

  .cs-button {
    color: #20409b;
    background-color: white;
    border: 1px solid #20409b;
    min-width: 40%;
    min-height: 40px;
  }

  .cs-link {
    text-decoration: underline;
    color: #20409b;
  }

  .cs-input {
    min-height: 40px;
    // background-color: #f1f7fc;
  }

  // ::v-deep {
  //   .el-input__inner {
  //     min-height: 40px;
  //     background-color: #f1f7fc !important;
  //   }

  //   .el-input-group__append {
  //     border-left: 1px solid #dcdfe6;
  //   }
  // }

  .cs-upload {
    border: 1px dashed #476dd3;
    border-radius: 10px;
  }
}
</style>
